/**
 * Constants
 *
 * @desc Sentry constants
 */

export default {
  SENTRY: {
    RELEASE: `${process.env.DOMAIN}-frontend@${process.env.APP_VERSION}`,
    DSN: 'https://ceef9a6e5ab74bb4b5d78a4d36dbf540@o281606.ingest.sentry.io/5975672',
    ENVIRONMENTS: {
      development: [
        'localhost',
        'ymere.verhuisregelingen.nl.local'
      ],
      test: [
        'ymere.verhuisregelingen.nl.test.uselab.com'
      ],
      acceptance: [
        'ymere.accept.verhuisregelingen.nl'
      ],
      production: [
        'ymere.verhuisregelingen.nl'
      ]
    }
  }
}
